import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const Layout = r => require.ensure([], () => r(require('@/layout/index.vue')), 'Layout');
// const dashboard = r => require.ensure([], () => r(require('@/views/dashboard/index.vue')), 'dashboard');
const login = r => require.ensure([], () => r(require('@/views/login/index.vue')), 'login');
const error = r => require.ensure([], () => r(require('@/views/404.vue')), 'error');
//用户体系注册
const authingIndex = r => require.ensure([], () => r(require('@/views/login/Registered/authingIndex.vue')), 'authingIndex');
//投诉举报
const Complaints = r => require.ensure([], () => r(require('@/views/login/Complaints/index.vue')), 'Complaints');
//注册
const Registered = r => require.ensure([], () => r(require('@/views/login/Registered/index.vue')), 'Registered');
//忘记密码
const ForgetPassword = r => require.ensure([], () => r(require('@/views/login/ForgetPassword/index.vue')), 'ForgetPassword');
//供应商分类
const Supplier = r => require.ensure([], () => r(require('@/views/login/Supplier/index.vue')), 'Supplier');
//供应商分详情
const SupplierDetails = r => require.ensure([], () => r(require('@/views/login/Supplier/SupplierDetails.vue')), 'SupplierDetails');
//项目详情
const itemDetails = r => require.ensure([], () => r(require('@/views/login/items/itemDetails.vue')), 'itemDetails');
const DetailManagement = r => require.ensure([], () => r(require('@/views/login/DetailManagement/index.vue')), 'DetailManagement');
//不良记录
const itemBadRecord = r => require.ensure([], () => r(require('@/views/login/items/itemBadRecord.vue')), 'itemBadRecord');
//公示列表
const PublicAnnouncementList = r => require.ensure([], () => r(require('@/views/login/PublicAnnouncementList/index.vue')), 'PublicAnnouncementList');
const projectList = r => require.ensure([], () => r(require('@/views/login/PublicAnnouncementList/projectList.vue')),'projectList');
//信用公示
const CreditAnnouncementList = r => require.ensure([], () => r(require('@/views/login/CreditAnnouncementList/index.vue')), 'CreditAnnouncementList');

//首页
const home = r => require.ensure([], () => r(require('@/views/home/index.vue')), 'home');
const EnterpriseInformationModify = r => require.ensure([], () => r(require('@/views/home/EnterpriseInformationModify.vue')), 'EnterpriseInformationModify');
//修改密码
const modifyListPassword = r => require.ensure([], () => r(require('@/views/home/modifyList/modifyListPassword.vue')), 'modifyListPassword');
//修改手机号
const modifyListTel = r => require.ensure([], () => r(require('@/views/home/modifyList/modifyListTel.vue')), 'modifyListTel');


/*todo ==========================================采购人消息中心相关的页面，禁止供应商系统使用============================================*/
//消息中心
const MeaasgeCenter = r => require.ensure([], () => r(require('@/views/MeaasgeCenter/index.vue')), 'MeaasgeCenter');
/*系统消息详情--通用*/
const system_info_TongYong = r => require.ensure([], () => r(require('@/views/MeaasgeCenter/system_info_TongYong.vue')), 'system_info_TongYong');
//消息中心详情
const messageDetails = r => require.ensure([], () => r(require('@/views/MeaasgeCenter/messageDetails.vue')), 'messageDetails');
//项目，公开询价详情
const messageDetailsGKXJ = r => require.ensure([], () => r(require('@/views/supplierLogin/MeaasgeCenter/messageDetailsGKXJ.vue')), 'gongYingShangXiangQin');
//消息中心手机变更详情
const messageDetailsPhoneMsg = r => require.ensure([], () => r(require('@/views/MeaasgeCenter/messageDetailsPhoneMsg.vue')), 'messageDetailsPhoneMsg');
//消息中心手机变更详情
const messageDetailsVerifyMsg = r => require.ensure([], () => r(require('@/views/MeaasgeCenter/messageDetailsVerifyMsg.vue')), 'messageDetailsVerifyMsg');
/*todo ========================================== end =============================================================*/
//问题答疑
const problemList = r => require.ensure([], () => r(require('@/views/problemList/index.vue')), 'problemList');
//问题答疑详情
const problemDetails = r => require.ensure([], () => r(require('@/views/problemList/problemDetails.vue')), 'problemDetails');
//问题答疑回答
const problemReply = r => require.ensure([], () => r(require('@/views/problemList/problemReply.vue')), 'problemReply');
//问题答疑回答
const problemAsk = r => require.ensure([], () => r(require('@/views/problemList/problemAsk.vue')), 'problemAsk');
//统计
const statisticsList = r => require.ensure([], () => r(require('@/views/statisticsList/index.vue')), 'statisticsList');
//采购
const purchaseList = r => require.ensure([], () => r(require('@/views/item/index.vue')), 'purchaseList');
//采购全部项目
const allItems = r => require.ensure([], () => r(require('@/views/item/allItems.vue')), 'allItems');
//采购-公开询价
const publicList = r => require.ensure([], () => r(require('@/views/item/publicList/index.vue')), 'publicList');

//采购-直接委托详情
const directSupplierContract = r => require.ensure([], () => r(require('@/views/item/publicList/directSupplierContract.vue')), 'directSupplierContract');
//采购-公开询价详情
const corporateInfoDetails = r => require.ensure([], () => r(require('@/views/item/publicList/corporateInfoDetails.vue')), 'corporateInfoDetails');

//采购-选择供应商(已废弃)
const chooseSupplier = r => require.ensure([], () => r(require('@/views/item/chooseSupplier.vue')), 'chooseSupplier');
//采购-合同上传预览
const supplierContract = r => require.ensure([], () => r(require('@/views/item/supplierContract.vue')), 'supplierContract');
//采购-选择供应商详情(已废弃)
// const chooseSupplierDetails = r => require.ensure([], () => r(require('@/views/item/chooseSupplierDetails.vue')), 'chooseSupplierDetails');
//评价
const evaluateList = r => require.ensure([], () => r(require('@/views/item/evaluateList.vue')), 'evaluateList');
//评价详情
const evaluateListDetails = r => require.ensure([], () => r(require('@/views/item/evaluateListDetails.vue')), 'evaluateListDetails');
//供应商-供应商报价详情
const supCorporateInfoDetails = r => require.ensure([], () => r(require('@/views/supplierLogin/item/supCorporateInfoDetails.vue')), 'supCorporateInfoDetails');


//供应商菜单
const supplierHome = r => require.ensure([], () => r(require('@/views/supplierLogin/home/index.vue')), 'supplierHome');
//供应商历史认证信息
const EnterpriseCertificationHistory = r => require.ensure([], () => r(require('@/views/supplierLogin/home/EnterpriseCertificationHistory.vue')), 'EnterpriseCertificationHistory');
//供应商认证
const supplierInformationModify = r => require.ensure([], () => r(require('@/views/supplierLogin/home/EnterpriseInformationModify.vue')), 'supplierInformationModify');

/*todo ==========================================供应商消息中心相关的页面，禁止采购人系统使用============================================*/
//供应商消息中心
const supplierMeaasgeCenter = r => require.ensure([], () => r(require('@/views/supplierLogin/MeaasgeCenter/index.vue')), 'supplierMeaasgeCenter');
const gongYingShangXiangQin = r => require.ensure([], () => r(require('@/views/supplierLogin/MeaasgeCenter/messageDetails.vue')), 'gongYingShangXiangQin');
/*todo==================================================== end =============================================================*/

//采购人管理列表
const PurchaserManagement = r => require.ensure([], () => r(require('@/views/supplierLogin/purchaserManagement/index.vue')), 'PurchaserManagement');
//供应商管理详情
const chooseSupplierDetails = r => require.ensure([], () => r(require('@/views/supplierLogin/purchaserManagement/chooseSupplierDetails.vue')), 'chooseSupplierDetails');
//项目记录
const ProjectRecord = r => require.ensure([], () => r(require('@/views/supplierLogin/purchaserManagement/ProjectRecord.vue')), 'ProjectRecord');
//未认证详情页面
const MessageDetails = r => require.ensure([], () => r(require('@/views/supplierLogin/purchaserManagement/MessageDetails.vue')), 'MessageDetails');
//供应商问题答疑
const supplierproblemList = r => require.ensure([], () => r(require('@/views/supplierLogin/problemList/index.vue')), 'supplierproblemList');
//供应商问题答疑详情
const supplierproblemDetails = r => require.ensure([], () => r(require('@/views/supplierLogin/problemList/problemDetails.vue')), 'supplierproblemDetails');
//供应商问题答疑回答
const supplierproblemReply = r => require.ensure([], () => r(require('@/views/supplierLogin/problemList/problemReply.vue')), 'supplierproblemReply');
//统计
const supplierStatisticsList = r => require.ensure([], () => r(require('@/views/supplierLogin/statisticsList/index.vue')), 'supplierStatisticsList');
//项目管理
const supplierPurchaseList = r => require.ensure([], () => r(require('@/views/supplierLogin/item/index.vue')), 'supplierPurchaseList');


//项目管理-已公示
const supplierChooseSupplierDetails = r => require.ensure([], () => r(require('@/views/supplierLogin/item/chooseSupplierDetails.vue')), 'supplierChooseSupplierDetails');
//已发布供应商详情
const publishedSuppliersDetails = r => require.ensure([], () => r(require('@/views/supplierLogin/item/publishedSuppliersDetails.vue')), 'publishedSuppliersDetails');

//项目管理-合同预览
const supplierSupplierContract = r => require.ensure([], () => r(require('@/views/supplierLogin/item/supplierContract.vue')), 'supplierSupplierContract');
const xiangQin = r => require.ensure([], () => r(require('@/views/supplierLogin/item/zhixuan/xiangQin.vue')), 'xiangQin');
//项目管理-合同预览
const itemOffter = r => require.ensure([], () => r(require('@/views/supplierLogin/item/itemOffter.vue')), 'itemOffter');


/*todo ===================================采购人项目相关的页面=======================================*/
//采购人历史认证信息
const PurEnterpriseCertificationHistory = r => require.ensure([], () => r(require('@/views/home/PurEnterpriseCertificationHistory.vue')), 'PurEnterpriseCertificationHistory');
//供应商查询
const SupplierList = r => require.ensure([], () => r(require('@/views/item/supplierManagement/index.vue')), 'SupplierList');
//供应商未认证详情页面
const SupplierMessageDetails = r => require.ensure([], () => r(require('@/views/item/supplierManagement/SupplierMessageDetails.vue')), 'SupplierMessageDetails');
//供应商项目记录
const SupplierRecord = r => require.ensure([], () => r(require('@/views/item/supplierManagement/SupplierRecord.vue')), 'SupplierRecord');
/*框架协议-新增*/
const frameworkAdd = r => require.ensure([], () => r(require('@/views/item/publicList/add/frameworkAdd.vue')), 'jxAdd');
/*框架协议-发布*/
const releasePage = r => require.ensure([], () => r(require('@/views/item/publicList/details/framework/releasePage.vue')), 'releasePage');
/*框架协议-公示*/
const publicityPage = r => require.ensure([], () => r(require('@/views/item/publicList/details/framework/publicityPage.vue')), 'publicityPage');
/*竞选--新增*/
const jxAdd = r => require.ensure([], () => r(require('@/views/item/publicList/add/jxAdd.vue')), 'jxAdd');
/*直选--新增*/
const zxAdd = r => require.ensure([], () => r(require('@/views/item/publicList/add/zxAdd.vue')), 'zxAdd');
/*竞选--已保存--详情*/
const jxYiBaoCun = r => require.ensure([], () => r(require('@/views/item/publicList/details/jingxuan/jxYiBaoCun.vue')), 'jxYiBaoCun');
/*竞选--已发布--详情*/
const jxYiFaBu = r => require.ensure([], () => r(require('@/views/item/publicList/details/jingxuan/jxYiFaBu.vue')), 'jxYiFaBu');
/*竞选--已公示--详情*/
const jxYiGongShi = r => require.ensure([], () => r(require('@/views/item/publicList/details/jingxuan/jxYiGongShi.vue')), 'jxYiGongShi');
/*直选--已保存--详情*/
const zxYiBaoCun = r => require.ensure([], () => r(require('@/views/item/publicList/details/zhixuan/zxYiBaoCun.vue')), 'zxYiBaoCun');
/*直选--已发布--详情*/
const zxYiFaBu = r => require.ensure([], () => r(require('@/views/item/publicList/details/zhixuan/zxYiFaBu.vue')), 'zxYiFaBu');
/*直选--已公示--详情*/
const zxYiGongShi = r => require.ensure([], () => r(require('@/views/item/publicList/details/zhixuan/zxYiGongShi.vue')), 'zxYiGongShi');
/*企业--报价信息详情*/
const baojiaXiangQin = r => require.ensure([], () => r(require('@/views/item/publicList/details/qiye/baojiaXiangQin.vue')), 'baojiaXiangQin');

//整改
const rectifyList = r => require.ensure([], () => r(require('@/views/rectifyList/index.vue')), 'rectifyList');
//整改详情
const rectifyDetails = r => require.ensure([], () => r(require('@/views/rectifyList/rectifyDetails.vue')), 'rectifyDetails');
//发布公告
const announcemenMessage = r => require.ensure([], () => r(require('@/views/MeaasgeCenter/announcemenMessage.vue')), 'announcemenMessage');

/*todo ==============================================================================================*/


export const constantRoutes = [
  {
    path: '/404',
    component: error,
    meta: {title: '404', icon: ''},
    hidden: true
  },
  // 404 page must be placed at the end !!!
  {path: '*', redirect: '/404', hidden: true},
  {
    path: '/',
    component: login,
    meta: {title: '用户登录', icon: ''},
    hidden: true
  },
  {
    path: '/authingIndex',
    component: authingIndex,
    meta: {title: '用户体系注册信息', icon: ''},
    hidden: true
  },
  {
    path: '/Complaints',
    component: Complaints,
    meta: {title: '投诉举报', icon: ''},
  },
  {
    path: '/Registered',
    component: Registered,
    meta: {title: '注册', icon: ''},
  },
  {
    path: '/ForgetPassword',
    component: ForgetPassword,
    meta: {title: '忘记密码', icon: ''},
  },
  {
    path: '/Supplier',
    component: Supplier,
    meta: {title: '供应商分类', icon: ''},
  },
  {
    path: '/SupplierDetails',
    component: SupplierDetails,
    meta: {title: '供应商详情', icon: ''},
  },
  {
    path: "/DetailManagement",
    component: DetailManagement,
    meta: {title: "资讯详情", icon: ""}
  },


  {
    path: '/itemDetails',
    component: itemDetails,
    meta: {title: '项目详情', icon: ''},
  },
  {
    path: '/itemBadRecord',
    component: itemBadRecord,
    meta: {title: '不良记录', icon: ''},
  },
  {
    path: '/PublicAnnouncementList',
    component: PublicAnnouncementList,
    meta: {title: '公示列表', icon: ''},
  },
  {
    path: '/projectList',
    component: projectList,
    meta: {title: '项目公示列表', icon: ''},
  },
  {
    path: '/CreditAnnouncementList',
    component: CreditAnnouncementList,
    meta: {title: '信用公示', icon: ''},
  },
  {
    path: '/',
    component: Layout,
    redirect: '/404',
    children: [
      //采购
      {
        path: "/home",
        name: "home",
        component: home,
        meta: {title: "首页", icon: ""}
      },
      {
        path: "/EnterpriseInformationModify",
        name: "EnterpriseInformationModify",
        component: EnterpriseInformationModify,
        meta: {title: "企业变更", icon: ""}
      },
      {
        path: "/EnterpriseCertificationHistory",
        name: "EnterpriseCertificationHistory",
        component: EnterpriseCertificationHistory,
        meta: {title: "企业历史信息", icon: ""}
      },
      {
        path: "/modifyListTel",
        name: "modifyListTel",
        component: modifyListTel,
        meta: {title: "修改手机号", icon: ""}
      },
      {
        path: "/modifyListPassword",
        name: "modifyListPassword",
        component: modifyListPassword,
        meta: {title: "修改密码", icon: ""}
      },
      {
        path: "/MeaasgeCenter",
        name: "MeaasgeCenter",
        component: MeaasgeCenter,
        meta: {title: "消息中心", icon: ""}
      },
      {
        path: "/messageDetailsGKXJ",
        name: "messageDetailsGKXJ",
        component: messageDetailsGKXJ,
        meta: {title: "公开询价报价消息详情", icon: ""}
      },
      {
        path: "/messageDetails",
        name: "messageDetails",
        component: messageDetails,
        meta: {title: "报价消息详情", icon: ""}
      },
      {
        path: "/messageDetailsPhoneMsg",
        name: "messageDetailsPhoneMsg",
        component: messageDetailsPhoneMsg,
        meta: {title: "手机变更消息详情", icon: ""}
      },
      {
        path: "/system_info_TongYong",
        name: "system_info_TongYong",
        component: system_info_TongYong,
        meta: {title: "消息详情", icon: ""}
      },


      {
        path: "/messageDetailsVerifyMsg",
        name: "messageDetailsVerifyMsg",
        component: messageDetailsVerifyMsg,
        meta: {title: "审核结果消息详情", icon: ""}
      },
      {
        path: "/problemList",
        name: "problemList",
        component: problemList,
        meta: {title: "问题答疑", icon: ""}
      },
      {
        path: "/problemDetails",
        name: "problemDetails",
        component: problemDetails,
        meta: {title: "问题答疑详情", icon: ""}
      },
      {
        path: "/problemReply",
        name: "problemReply",
        component: problemReply,
        meta: {title: "问题答疑回答", icon: ""}
      },
      {
        path: "/problemAsk",
        name: "problemAsk",
        component: problemAsk,
        meta: {title: "问题咨询", icon: ""}
      },
      {
        path: "/statisticsList",
        name: "statisticsList",
        component: statisticsList,
        meta: {title: "统计", icon: ""}
      },
      {
        path: "/ppurchaseList",
        name: "purchaseList",
        component: purchaseList,
        children: [
          {
            path: "allItems",
            name: "allItems",
            component: allItems,
          },
          {
            path: "publicList",
            name: "publicList",
            component: publicList,
          },
          {
            path: "/PurEnterpriseCertificationHistory",
            name: "PurEnterpriseCertificationHistory",
            component: PurEnterpriseCertificationHistory,
            meta: { title: "采购人企业认证历史", icon: "", keepAlive: true }
          },
          {
            path: "/SupplierList",
            name: "SupplierList",
            component: SupplierList,
            meta: { title: "供应商查询", icon: "", keepAlive: true }
          },
          {
            path: "/SupplierMessageDetails",
            name: "SupplierMessageDetails",
            component: SupplierMessageDetails,
            meta: { title: "供应商详情", icon: "" }
          },
          {
            path: "/SupplierRecord",
            name: "SupplierRecord",
            component: SupplierRecord,
            meta: { title: "参与项目", icon: "" }
          },
          {
            path: "frameworkAdd",
            name: "frameworkAdd",
            component: frameworkAdd,
            meta: {title: "协议框架", icon: ""}
          },
          {
            path: "releasePage",
            name: "releasePage",
            component: releasePage,
            meta: {title: "协议框架-发布", icon: ""}
          },
          {
            path: "publicityPage",
            name: "publicityPage",
            component: publicityPage,
            meta: {title: "协议框架-公示", icon: ""}
          },
          {
            path: "jxAdd",
            name: "jxAdd",
            component: jxAdd,
            meta: {title: "竞选项目", icon: ""}
          },
          {
            path: "zxAdd",
            name: "zxAdd",
            component: zxAdd,
            meta: {title: "直选项目", icon: ""}
          }

        ]
      },
      {
        path: "/chooseSupplier",
        name: "chooseSupplier",
        component: chooseSupplier,
        meta: {title: "选择供应商", icon: ""}
      },
      {
        path: "/supplierContract",
        name: "supplierContract",
        component: supplierContract,
        meta: {title: "供应商合同上传下载", icon: ""}
      },
      {
        path: "/chooseSupplierDetails",
        name: "chooseSupplierDetails",
        component: chooseSupplierDetails,
        meta: {title: "选择供应商详情", icon: ""}
      },

      {
        path: "/baojiaXiangQin",
        name: "baojiaXiangQin",
        component: baojiaXiangQin,
        meta: {title: "企业报价信息", icon: ""}
      },



      {
        path: "/evaluateList",
        name: "evaluateList",
        component: evaluateList,
        meta: {title: "评价", icon: ""}
      },
      {
        path: "/evaluateListDetails",
        name: "evaluateListDetails",
        component: evaluateListDetails,
        meta: {title: "评价详情", icon: ""}
      },
      {
        path: "/directSupplierContract",
        name: "directSupplierContract",
        component: directSupplierContract,
        meta: {title: "直接委托详情", icon: ""}
      },

      {
        path: "/corporateInfoDetails",
        name: "corporateInfoDetails",
        component: corporateInfoDetails,
        meta: {title: "供应商详情", icon: ""}
      },

      //供应商
      {
        path: "/supplierHome",
        name: "supplierHome",
        component: supplierHome,
        meta: {title: "供应商首页", icon: ""}
      },
      {
        path: "/supCorporateInfoDetails",
        name: "supCorporateInfoDetails",
        component: supCorporateInfoDetails,
        meta: {title: "供应商报价详情", icon: ""}
      },
      {
        path: "/supplierInformationModify",
        name: "supplierInformationModify",
        component: supplierInformationModify,
        meta: {title: "供应商信息变更", icon: ""}
      },
      {
        path: "/supplierMeaasgeCenter",
        name: "supplierMeaasgeCenter",
        component: supplierMeaasgeCenter,
        meta: {title: "供应商消息中心", icon: ""}
      },
      {
        path: "/PurchaserManagement",
        name: "PurchaserManagement1",
        component: PurchaserManagement,
        meta: { title: "采购人管理", icon: "", keepAlive: true }
      },
      {
        path: "/chooseSupplierDetails",
        name: "chooseSupplierDetails",
        component: chooseSupplierDetails,
        meta: { title: "供应商管理详情", icon: "" }
      },
      {
        path: "/ProjectRecord",
        name: "ProjectRecord",
        component: ProjectRecord,
        meta: { title: "项目记录", icon: "" }
      },
      {
        path: "/MessageDetails",
        name: "MessageDetails",
        component: MessageDetails,
        meta: { title: "未认证详情页", icon: "" }
      },
      {
        path: "/supplierproblemList",
        name: "supplierproblemList",
        component: supplierproblemList,
        meta: {title: "供应商问题答疑", icon: ""}
      },
      {
        path: "/supplierproblemDetails",
        name: "supplierproblemDetails",
        component: supplierproblemDetails,
        meta: {title: "供应商问题答疑详情", icon: ""}
      },
      {
        path: "/supplierproblemReply",
        name: "supplierproblemReply",
        component: supplierproblemReply,
        meta: {title: "供应商问题答疑回答", icon: ""}
      },

      {
        path: '/gongYingShangXiangQin',
        component: gongYingShangXiangQin,
        meta: {title: '供应消息详情', icon: ''},
      },

      {
        path: "/supplierStatisticsList",
        name: "supplierStatisticsList",
        component: supplierStatisticsList,
        meta: {title: "供应商统计页面", icon: ""}
      },
      {
        path: "/supplierPurchaseList",
        name: "supplierPurchaseList",
        component: supplierPurchaseList,
        meta: {title: "供应商项目管理", icon: ""}
      },
      {
        path: "/publishedSuppliersDetails",
        name: "publishedSuppliersDetails",
        component: publishedSuppliersDetails,
        meta: {title: "已发布供应商详情", icon: ""}
      },
      {
        path: "/supplierChooseSupplierDetails",
        name: "supplierChooseSupplierDetails",
        component: supplierChooseSupplierDetails,
        meta: {title: "供应商参与报价", icon: ""}
      },
      {
        path: "/supplierSupplierContract",
        name: "supplierSupplierContract",
        component: supplierSupplierContract,
        meta: {title: "供应商合同上传", icon: ""}
      },
      {
        path: "/xiangQin",
        name: "xiangQin",
        component: xiangQin,
        meta: {title: "直选项目详情", icon: ""}
      },
      {
        path: "/itemOffter",
        name: "itemOffter",
        component: itemOffter,
        meta: {title: "参与项目", icon: ""}
      },
      {
        path: "/jxYiBaoCun",
        name: "jxYiBaoCun",
        component: jxYiBaoCun,
        meta: {title: "项目已保存", icon: ""}
      },
      {
        path: "/jxYiFaBu",
        name: "jxYiFaBu",
        component: jxYiFaBu,
        meta: {title: "项目已发布", icon: ""}
      },
      {
        path: "/jxYiGongShi",
        name: "jxYiGongShi",
        component: jxYiGongShi,
        meta: {title: "项目已公示", icon: ""}
      },
      {
        path: "/zxYiBaoCun",
        name: "zxYiBaoCun",
        component: zxYiBaoCun,
        meta: {title: "项目已保存", icon: ""}
      },

      {
        path: "/zxYiFaBu",
        name: "zxYiFaBu",
        component: zxYiFaBu,
        meta: {title: "项目已发布", icon: ""}
      },
      {
        path: "/zxYiGongShi",
        name: "zxYiGongShi",
        component: zxYiGongShi,
        meta: {title: "项目已公示", icon: ""}
      },
      {
        path: "/rectifyList",
        name: "rectifyList",
        component: rectifyList,
        meta: { title: "整改", icon: "" }
      },
      {
        path: "/rectifyDetails",
        name: "rectifyDetails",
        component: rectifyDetails,
        meta: { title: "整改详情", icon: "" }
      },
      {
        path: "/announcemenMessage",
        name: "announcemenMessage",
        component: announcemenMessage,
        meta: { title: "查看公告", icon: "" }
      },
    ]
  },
]
const createRouter = () => new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({y: 0}),
  //base: '/nanfan_admin/',
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js